import React, {useEffect, useRef, useState} from "react";
import ParticipantSelectorPopup from "./ParticipantSelectorPopup";
import participantString from "../participantString/participantString";

const ParticipantInput = (props) => {

  const {
    types,
    onChange,
    error
  } = props;

  const [selection, setSelection] = useState([]);
  const [focus, setFocus] = useState(false);
  const ref = useRef();

  useEffect(() => {
    setSelection(types);
  }, [types]);

  useEffect(() => {
    if (focus) {
      document.addEventListener('click', handleClickOutside, true);
    } else {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [focus]);


  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setFocus(false);
    }
  }

  const computeString = () => {
    return participantString(selection);
    // let str = '';
    // selection.map((entry) => {
    //   if (entry.value) {
    //     str += (str ? ', ' : '') + `${entry.label.charAt(0).toUpperCase()}${entry.label.slice(1)} ${entry.value}`;
    //   }
    // });
    // return str;
  }


  return <div ref={ref}>
    <input
      type="text"
      aria-labelledby="passengers"
      required={true}
      value={computeString()}
      onFocus={() => { setFocus(true) }}
      onChange={() => {}}
      placeholder="Select passengers"
      className={error ? 'error' : ''}
    />
    {focus && <ParticipantSelectorPopup
      onChange={(val) => {
        if (onChange) {
          onChange(val);
        }
      }}
      types={types}
      onClose={() => setFocus(false)} />}
  </div>

}

export default ParticipantInput;
